import React from "react";

import styled from "styled-components";

import { Tooltips } from ".";

import meetingImg from "../assets/gfx/04_meeting.jpg";

export const WorkplaceAssessment: React.FC<{}> = () => {
  return (
    <div className="row">
      <div className="col-md-10 col-lg-8 mx-auto">
        <h2 className="h1 text-uppercase text-center text-warning mb-4">
          Workplace assessment and consultation
        </h2>
        <img
          className="img-fluid mx-3 mb-4"
          src={meetingImg}
          alt="Work colleagues in a meeting"
        />
        <p className="text-center mb-4">
          All workplaces (and their employees) are different, which means there
          is no "one size fits all" solution. It’s important to assess your
          workplace and consult with staff in order to understand what is
          impacting on health behaviours, so that solutions can be found to
          improve them.<Tooltips id={24} /> Use assessment and consultation to answer:
        </p>
        <div className="row mb-4">
          <div className="col-md-4 text-center">
            <StyledSpan className="text-info">1</StyledSpan>
            <strong className="text-center text-info">
              What are the current gaps and barriers?
            </strong>
          </div>
          <div className="col-md-4 text-center">
            <StyledSpan className="text-info">2</StyledSpan>
            <strong className="text-center text-info">
              What do employees want?
            </strong>
          </div>
          <div className="col-md-4 text-center">
            <StyledSpan className="last text-info">3</StyledSpan>
            <strong className="text-center text-info">
              How can things be improved?
            </strong>
          </div>
        </div>
      </div>
    </div>
  );
};

const StyledSpan = styled.span`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  height: 1.2rem;
  width: 1.2rem;
  font-size: 0.8rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border: 1px solid ${(p) => p.theme.info};
    border-radius: 50%;
  }
  &:not(.last)::after {
    content: "";
    position: absolute;
    top: 0.6rem;
    left: calc(1.2rem + 2rem);
    width: 10rem;
    height: 1px;
    background: ${(p) => p.theme.info};
  }
`;
